import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Button, Form, Icon} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import toastr from 'toastr';

import usersApi from '../../store/services/users';
import {connect} from 'react-redux';
import Whitelist from '../../store/services/whitelist';
import FormContainer from '../form-components/FormContainer';
import {ErrorMessages} from '../form-components/ErrorMessages';
import WhitelistForm from './WhitelistForm';

class NewWhitelistScreen extends Component {
  state = {
    loading: false,
    whitelist: {
      userId: undefined,
      firstName: '',
      lastName: '',
      emailAddress: '',
      customer: '',
    },
    error: {},
    userError: false,
    hasUserId: false,
    user: {},
  };

  _mutate = cb => {
    this.setState(produce(cb));
  };

  _handleTextChanged = (event, {name, value}) => {
    this._mutate(draft => {
      draft.whitelist[name] = value;
    });
  };

  _whitelist = async emailAddress => {
    let user = await usersApi.fetchByEmail(emailAddress);

    withLifecycles(
      () =>
        Whitelist.whitelist({
          ...user.result,
          userId: user.result.id,
          customer: user.result.company || user.result.customerName,
        }),
      ({loading, data, error}) => {
        this.setState(
          produce(draft => {
            draft.saving = loading;
            draft.error = error;

            if (data && !data.hasErrors) {
              this._loadWhitelists(0, '');
              this.props.history.push('/manage/whitelists');
              toastr.success('User Whitelisted');
            }
          }),
        );
      },
    );
  };

  _loadWhitelists = (pageNumber, searchTerm) => {
    withLifecycles(
      () =>
        Whitelist.fetch({
          request: {
            page: pageNumber,
            pageSize: 20,
          },
          searchTerm: searchTerm,
          orderByName: false,
        }),
      ({loading, data}) => {
        this.setState({activePage: pageNumber + 1});
        this.setState(
          produce(draft => {
            draft.loading = loading;

            if (data && !data.hasErrors) {
              draft.pageInfo = data.result;
            }
          }),
        );
      },
    );
  };

  _save = () => {
    withLifecycles(
      () => Whitelist.whitelist(this.state.whitelist),
      ({loading, data, error}) => {
        this._mutate(draft => {
          draft.loading = loading;
          draft.error = error;
          this.userError = false;
          let errorLength = (draft.error.errors || []).length;
          let errorMessages = (draft.error.errors || []).map(
            x => x.errorMessage,
          );

          if (data && !data.hasErrors) {
            this._loadWhitelists(0, '');
            toastr.success('Whitelist Created');
            this.props.history.push('/manage/whitelists');
          } else if (
            errorLength === 1 &&
            errorMessages[0] ===
            'A user with this email address already exists.'
          ) {
            this.userError = true;
          }
        });
      },
    );
  };

  render() {
    const {error, loading, whitelist} = this.state;

    return (
      <FormContainer loading={loading}>
        <Form onSubmit={this._save}>
          <WhitelistForm
            whitelist={whitelist}
            handleTextChanged={this._handleTextChanged}
            isReadOnly={false}
            isBeingEdited={false}
          />
          <ErrorMessages error={error} />
          <Button type="submit">
            <Icon
              style={{paddingRight: '15px'}}
              name="check circle"
              color="Black"
            />
            Whitelist
          </Button>
          {this.userError === true && (
            <Button
              type="button"
              color="red"
              content="Would you like to whitelist this user?"
              onClick={() => this._whitelist(whitelist.emailAddress)}
            >
              Whitelist this user
            </Button>
          )}
          <Button basic as={Link} to="/manage/whitelists">
            Cancel
          </Button>
        </Form>
      </FormContainer>
    );
  }
}

const mapStateToProps = ({customers, identity}) => ({
  customers: customers.data,
  role: identity.user.role,
});

export default connect(mapStateToProps)(NewWhitelistScreen);
